<template>
  <div id="liste_devis_pro_forma">
    <div id="zone_ambassade">
      <b-col cols="12">
        <h2 :class="showDetails.ambassade ? 'rotate active' : 'no-rotate'">
          Ambassades
          <i
            class="fas fa-chevron-left"
            @click="toggleAmbassades"
          />
          <span class="separator" />
        </h2>
      </b-col>
      <b-col
        id="tableau_devis"
        cols="12"
      >
        <GenericTable
          v-show="showDetails.ambassade"
          ref="genericTableDevisAmbassade"
          :name="namespaceAmbassade"
          :actions="actions"
          :colonnes="colsDevis"
          :endpoint-url="endpointAmbassade"
          :filterable-col="filterableColAmbassade"
          :extra-filters="extraFiltersAmbassade"
          :display-archive-checkbox="false"
          :no-checkbox="isUserNh ? false : true"
          verbose-namespace="Devis ambassade"
          @row-click="openDetailsAmbassade"
          @action-callback="dispatchAction($event, 'devis')"
        />
      </b-col>
    </div>

    <div
      v-if="isUserNh"
      id="zone_libraire"
    >
      <b-col cols="12">
        <h2 :class="showDetails.libraire ? 'rotate active' : 'no-rotate'">
          Libraires
          <i
            class="fas fa-chevron-left"
            @click="toggleLibraires"
          />
          <span class="separator" />
        </h2>
      </b-col>
      <b-col cols="12">
        <GenericTable
          v-show="showDetails.libraire"
          ref="genericTableProFormaLibraire"
          :name="namespaceLibraire"
          :actions="actions"
          :colonnes="colsProForma"
          :endpoint-url="endpointLibraire"
          :filterable-col="filterableColLibraire"
          :display-archive-checkbox="false"
          verbose-namespace="Pro forma libraire"
          @row-click="openDetailsLibraire"
          @action-callback="dispatchAction($event, 'pro_forma')"
        />
      </b-col>
    </div>
    <AmbassadeModal :namespace-tab-liste-cmd-ambassade="namespaceAmbassade" />
    <LibraireModal :namespace-tab-liste-cmd-libraire="namespaceLibraire" />
    <ModalExportCommandesFactures />
  </div>
</template>

<script>
import GenericTable from "@/components/generics/genericTable/GenericTable.vue";
import LibraireModal from "@/components/libraires/LibraireModal.vue";
import AmbassadeModal from "@/components/ambassades/AmbassadeModal.vue";
import ModalExportCommandesFactures from "@/components/commandes/ModalExportCommandesFactures.vue";

import Api from "@/modules/axios";
import { displayErrorSelectOne } from "@/modules/utils";
import { spaceNumber, moneyFilter } from "@/modules/filters";

export default {
  name: "ListeCommandes",
  components: {
    GenericTable,
    LibraireModal,
    AmbassadeModal,
    ModalExportCommandesFactures,
  },
  data() {
    return {
      namespaceAmbassade: "devis_ambassade",
      namespaceLibraire: "pro_forma_libraire",
      endpointAmbassade: "/devis",
      endpointLibraire: "/pro_forma",
      colsDevis: [
        {
          key: "numero",
          defaultOrder: true,
          sensOrder: "-",
        },
        { key: "date" },
        { key: "ambassade" },
        { key: "pays__nom", overrideName: "Pays" },
        { key: "date_modification" },
        { key: "user_updated" },
        { key: "nb_ouvrages" },
        { key: "prix_total", overrideName: "Montant (€)" },
      ],
      colsProForma: [
        {
          key: "numero",
          defaultOrder: true,
          sensOrder: "-",
        },
        { key: "date" },
        { key: "libraire" },
        { key: "pays__nom", overrideName: "Pays" },
        { key: "date_modification" },
        { key: "user_updated" },
        { key: "nb_ouvrages" },
        { key: "prix_total", overrideName: "Montant (€)" },
      ],
      filterableColAmbassade: ["numero", "ambassade__compte", "pays__nom"],
      filterableColLibraire: ["numero", "libraire__compte", "pays__nom"],
      showDetails: {
        ambassade: false,
        libraire: false,
      },
      extraFiltersAmbassade: { tenant: this.$store.getters.typeUser.id },
    };
  },
  computed: {
    actions() {
      return this.isUserNh ? [{ title: "Exporter", callback: "export" }] : [];
    },
    isUserNh() {
      return this.$store.getters.typeUser.nom === "NH";
    },
  },
  mounted() {
    this.$store.commit(
      `${this.namespaceAmbassade}/setFormatDataFunction`,
      this.verboseColsForTable,
    );
    this.$store.commit(
      `${this.namespaceLibraire}/setFormatDataFunction`,
      this.verboseColsForTable,
    );
  },
  methods: {
    /**
     * Affiche/masque le tableau des ambassades et définit le namespace du tableau de recherche.
     * @public
     */
    toggleAmbassades() {
      this.showDetails.ambassade = !this.showDetails.ambassade;
      this.$store.commit("setNamespaceSearch", 0);
    },
    /**
     * Affiche/masque le tableau des libraires et définit le namespace du tableau de recherche.
     * @public
     */
    toggleLibraires() {
      this.showDetails.libraire = !this.showDetails.libraire;
      this.$store.commit("setNamespaceSearch", 1);
    },
    /**
     * Affiche les détails du devis.
     * @public
     * @param {Object} devis Devis sélectionné.
     */
    openDetailsAmbassade(devis) {
      Api()
        .get(`ambassade/${devis.ambassade}`)
        .then((res) => {
          this.$modal.show("ambassade", {
            devisId: devis.id,
            ambassade: res.data,
          });
        });
    },
    /**
     * Affiche les détails de la pro forma.
     * @public
     * @param {Object} devis Pro forma sélectionnée.
     */
    openDetailsLibraire(proForma) {
      Api()
        .get(`libraire/${proForma.libraire}`)
        .then((res) => {
          this.$modal.show("libraire", {
            proFormaId: proForma.id,
            libraire: res.data,
          });
        });
    },
    /**
     * Exécute les actions des tableaux des devis et pro forma.
     * @public
     * @param {String} actionCode Action sélectionnée.
     * @param {String} type Définit le tableau depuis lequel l'action est effectuée.
     */
    dispatchAction(actionCode, type) {
      let namespace = null;
      let endpoint = null;
      let msg = "une pro forma";

      if (type === "devis") {
        namespace = this.namespaceAmbassade;
        endpoint = this.endpointAmbassade;
        msg = "un devis";
      } else {
        namespace = this.namespaceLibraire;
        endpoint = this.endpointLibraire;
      }

      // On execute le dispatch générique qui gère le delete
      const resCode = this.$refs.genericTableProFormaLibraire.genericDispatch(
        actionCode,
        namespace,
        endpoint,
        msg,
      );

      if (resCode === -1) {
        const checkedRows = this.$store.getters[
          `${namespace}/rowDisplayed`
        ].filter((row) => row._checkBoxChecked);

        switch (actionCode) {
          case "export":
            if (checkedRows.length === 1) {
              this.displayModalExport(namespace, type);
            } else {
              displayErrorSelectOne(msg);
            }
            break;

          default:
            break;
        }
      }
    },
    /**
     * Met en forme les données des tableaux des devis et pro forma.
     * @public
     * @param {Object} data Données du tableau.
     * @return {Promise}
     */
    verboseColsForTable(data) {
      const { results } = data;

      // Verbose de l'user (modifié par)
      const usersUpdatedIds = [
        ...new Set(results.map((item) => item.user_updated)),
      ];

      const promise1 = Api()
        .get(`user/?id__in=${usersUpdatedIds.join(",")}&page_size=100`)
        .then((res) => {
          const tabUserUpdated = res.data.results;
          results.forEach((ligne) => {
            ligne.user_updated_verbose = (
              tabUserUpdated.find(
                (userUpdated) => ligne.user_updated === userUpdated.id,
              ) || {}
            ).username;
          });
          return res;
        });

      // Verbose de l'ambassade
      const ambassadesIds = [...new Set(results.map((item) => item.ambassade))];

      const promise2 = Api()
        .get(`ambassade/?id__in=${ambassadesIds.join(",")}&page_size=100`)
        .then((res) => {
          const tabAmbassades = res.data.results;
          results.forEach((ligne) => {
            ligne.ambassade_verbose = (
              tabAmbassades.find(
                (ambassade) => ligne.ambassade === ambassade.id,
              ) || {}
            ).nom;
          });
          return res;
        });

      // Verbose du libraire
      const librairesIds = [...new Set(results.map((item) => item.libraire))];

      const promise3 = Api()
        .get(`libraire/?id__in=${librairesIds.join(",")}&page_size=100`)
        .then((res) => {
          const tabLibraires = res.data.results;
          results.forEach((ligne) => {
            ligne.libraire_verbose = (
              tabLibraires.find(
                (libraire) => ligne.libraire === libraire.id,
              ) || {}
            ).nom;
          });
          return res;
        });

      // Verbose
      results.forEach((ligne) => {
        ligne.nb_ouvrages_verbose = spaceNumber(ligne.nb_ouvrages);

        ligne.prix_total_verbose = moneyFilter(ligne.prix_total);
      });

      return Promise.all([promise1, promise2, promise3]);
    },
    /**
     * Affiche la modale d'export.
     * @public
     * @param {String} namespace Namespace du tableau relatif à l'export.
     * @param {String} type Définit si le devis/la pro forma appartient à une ambassade/un libraire.
     */
    displayModalExport(namespace, type) {
      const checkedRows = this.$store.getters[`${namespace}/rowDisplayed`].filter(
        (row) => row._checkBoxChecked,
      );

      this.$modal.show("ModalExportCommandesFactures", {
        lignes: checkedRows,
        type,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#liste_devis_pro_forma::v-deep .table-content {
  .numero,
  .devis_commande { width: 200px; }

  .date,
  .date_modification { width: 150px; }

  .ambassade,
  .libraire { width: 200px; }

  .pays { width: 200px; }

  .user_updated { min-width: 250px; }

  .total_ouvrages { width: 150px; }

  .montant_euros { width: 150px; }
}
</style>
